import { MOUSE_MOVE } from '%paysera_seat_selection_integration/js/seatings/redux/components/workflow/actionTypes';

function filterAdminLogRocket() {
    return {
        actionSanitizer: (action) => {
            if ([MOUSE_MOVE].includes(action.type)) {
                return null;
            }
            return action;
        },
    };
}

export default filterAdminLogRocket;
